module.exports = __webpack_public_path__ + "img/deviceCheckBtn.48ce1aae.png";